import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject , throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import { CommonService } from "./common.service";
import { B2BUserDTO , CustomerDTO} from '@signature-it/ngx-generic/models';

@Injectable()
export class OrganizationService extends CommonService {
    managerList$ = new BehaviorSubject<CustomerDTO[]>([]);
    getManagerList$ = new BehaviorSubject<boolean>(false);

    getHierarchyTree(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.restUrlsConf.appURL}/org/hierarchy_tree.json`)
                .toPromise()
                .then(
                    res => { resolve(res); },
                    error => { reject(error); }
                );
        });
    }

    /**
     * @param string oid (user_number)
     * @param number uid (user_id)
     * @returns Observable<B2BUserDTO>
     */
    getUserDetails(oid: string, uid: number): Observable<B2BUserDTO> {
        return this.http.get(`${this.restUrlsConf.appURL}/org/${oid}/user/${uid}.json?full=1`)
            .pipe(map((res) => new B2BUserDTO(res)),
                catchError( (error: any) => throwError(error)));
    }

    /**
     *
     * @param string oid (user_number)
     * @param number aid (customer_id/user_id)
     * @returns Observable<B2BUserDTO[]>
     */
    getCustomerSubUsers(oid: string, aid: number): Observable<any> {
        return this.http.get(`${this.restUrlsConf.appURL}/org/${oid}/customer/${aid}/sub-users.json`)
            .pipe(map((res) => B2BUserDTO.createFromArray(res)),
                catchError( (error: any) => throwError(error)));
    }

    /**
     *
     * @param string oid (user_number)
     * @param number uid (user_id)
     * @param object params user's attributes to update
     * @returns Observable<boolean>
     */
    updateUserDetails(oid: string, uid: number, params: object): Observable<boolean> {
        return this.http.post(`${this.restUrlsConf.appURL}/org/${oid}/user/${uid}/details.json`, JSON.stringify(params))
            .pipe(map((res: boolean) => res),
                catchError( (error: any) => throwError(error)));
    }

    /**
     *
     * @param string oid (user_number)
     * @param object params
     * @returns Observable<B2BUserDTO>
     */
    addNewUser(oid: string, params: object): Observable<B2BUserDTO> {
        return this.http.post(`${this.restUrlsConf.appURL}/org/${oid}/user/add.json`, JSON.stringify(params))
            .pipe(map((res: any) => {
                params['user_id'] = Number(res) || 0;
                return new B2BUserDTO(params);
            }), catchError( (error: any) => throwError(error)));
    }

    /**
     *
     * @param number uid (user_id)
     * @returns Observable<boolean>
     */
    sendActivationEmail(uid: number): Observable<boolean> {
        return this.http.get(`${this.restUrlsConf.appURL}/org/user/${uid}/send-activation-email`)
            .pipe(map((res: boolean) => res),
                catchError( (error: any) => throwError(error)));
    }
}
